import { render, staticRenderFns } from "./AccreditationUpdateContainer.vue?vue&type=template&id=c0558396&scoped=true"
import script from "./AccreditationUpdateContainer.vue?vue&type=script&lang=js"
export * from "./AccreditationUpdateContainer.vue?vue&type=script&lang=js"
import style0 from "./AccreditationUpdateContainer.vue?vue&type=style&index=0&id=c0558396&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0558396",
  null
  
)

export default component.exports